import { render, staticRenderFns } from "./TarjetasSalud.vue?vue&type=template&id=a9f84ca4&scoped=true"
import script from "./TarjetasSalud.vue?vue&type=script&lang=js"
export * from "./TarjetasSalud.vue?vue&type=script&lang=js"
import style0 from "./TarjetasSalud.vue?vue&type=style&index=0&id=a9f84ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f84ca4",
  null
  
)

export default component.exports